import { DevelopmentScreening } from '../../content.types';

export const screenings: Record<string, DevelopmentScreening> = {};

export const screeningImages: Record<
  string,
  {
    internalName?: string;
    image: { url: string; title?: string; description?: string };
    description?: string;
    header?: string;
  }
> = {};
